import { EventEmitter } from "../../../utils";
import { events } from "../../../scripts/constants";
import { parse } from "node-html-parser";

type Message = string;

export const loadingTemplate = (message: string) =>
  `<div class="indicator"> <div class="icon"> <div></div> <div></div> <div></div> <div></div> <div></div> </div> <p class="text">${message}</p> </div>`;

export const startLoadingState = (message: Message, messageContainerSelector: string) => {
  const messageContainer = document.querySelector<HTMLElement>(messageContainerSelector);

  if (messageContainer) {
    messageContainer.innerHTML = "";

    const parsed = parse(message);
    messageContainer.insertAdjacentHTML("beforeend", parsed.outerHTML);

    document.body.classList.add("loading");
    messageContainer.classList.add("active");
  }
};

export const endLoadingState = (messageContainerSelector: string) => {
  const messageContainer = document.querySelector<HTMLElement>(messageContainerSelector);

  if (messageContainer) messageContainer.classList.remove("active");
  document.body.classList.remove("loading");

  if (window["dataLayer"]) {
    window["dataLayer"].push({ event: "optimize.activate" });
  }
};

EventEmitter.on(events.START_LOADING, (data: { message: string; selector: string }) => {
  startLoadingState(data.message, data.selector);
});

EventEmitter.on(events.STOP_LOADING, (data: { selector: string }) => {
  endLoadingState(data.selector);
});
